module.exports = {
  message: {
    Language: '繁',
    Home: '首頁',
    CompanyProfile: '公司簡介',
    CompanyCulture: '企業文化',
    News: '新聞資訊',
    ContactUs: '聯繫我們',
    CeBaRelatedPlatform: '測吧相關平台',
    FollowUs: '關注我們',
    ContactInformation: '聯繫方式',
    joinUs: '加入我們',
    socialRecruitment: '社會招聘',
    CampusRecruiting: '校園招聘',
    JobSelf_recommendation: '職位自薦',
    contactUs: '聯繫我們',
    customerService: '客戶服務',
    CooperationMeeting: '合作洽談',
    LegalInformation: '法律信息',
    ServiceAgreement: '服務協議',
    PrivacyPolicy: '隱私政策',
    InvoiceAndQualityCertificateQueryPlatform: '質博士',
    OnlineVerificationPlatformFor: '電子文件簽名驗證平台',
    ElectronicSignatureDocume: '電子文件服務平台',
    CompanyIntroduction: '公司介紹',
    DevelopmentPath: '發展歷程',
    QualificationHonor: '資質榮譽',
    Partner: '合作夥伴',
    CompanyProfileP1: '測吧，是以質量為核心要素的互聯網基礎設施與服務平台,通過"開放平台+信息智能平台+業務定制平台"的方式,為企業和個人提供以質量信息服務。',
    CompanyProfileP2: '我們的願景是做真實質量信息的傳遞者，履行著讓品質帶來歡樂的使命。',
    CompanyProfileP3: '我們的業務有來簽雲平台、企查查：',
    CompanyProfileP4: '來簽雲平台',
    CompanyProfileP5: '企業和個人的契約身份證發放，真實信息文件的簽約，驗證，並建立可閱可信的商品質量標準和合同文書，提升企業經營和供應鏈管理效率、以及強化個人契約安全保障',
    CompanyProfileP6: '企查查',
    CompanyProfileP7: '通過互聯網手段，為企業提供真實有效的質量信息，深挖、創新業務，提供質量信息場景應用服務',
    CompanyProfileP8: `我們的合作夥伴包括《電子簽名法》的頒發者：國家認監委、3C產品行業標準的建立者：工業富聯商超的頭部玩家：華潤萬家、國內僅有的四大國際CA頒發機構之一：上海市數字證書認證中心等。`,
    Vision: '願景',
    Mission: '使命',
    Value: '價值觀',
    CompanyCultureMission: `真實質量資訊的形成與傳遞關乎生產企業、賣場、電商平臺、檢驗檢測認證機構、消費者和其它類型企業在內的所有參與者的利益。市場行為疊加消費者的消費心理和習慣，造成產品品質資訊的傳遞過程和結果是扭曲和不真實的，我們深信讓消費者隨時、隨地、隨心的接收到真實的產品品質資訊，並參與、監督、討論產品質量，有利於改變消費者的消費心理和習慣，增强企業提升產品品質和持續創新的動力。`,
    CompanyCultureVision: `我們為生產企業、賣場、電商平臺、檢驗檢測認證機構、消費者和其它類型企業在內的所有參與者提供以質量為覈心要素的互聯網基礎設施與服務平臺，讓參與者得到有價值的服務，並借助新技術的力量加强互動，共同來提升品質、享受品質帶來的歡樂，並進入良性互動迴圈。同時我們不斷創新與融合以質量為覈心要素的各項服務，更好的服務所有參與者。`,
    CompanyCultureValueP1: `我們相信，强大的共同價值觀是塑造公司的企業文化、公司發展壯大及永續經營的基石。測吧的價值觀對於我們如何經營業務、招攬人才、考核員工以及决定員工報酬扮演著重要的角色：`,
    CompanyCultureValueP2: `1、客戶至上：客戶是公司存在的唯一理由 `,
    CompanyCultureValueP3: `2、勇於創新：勇於改變，持續創新`,
    CompanyCultureValueP4: `3、團隊合作：尊重差异、敢於擔當  `,
    CompanyCultureValueP5: `4、夢想：綻放生命、永不言弃`,
    CompanyCultureValueP6: `5、誠信：真誠坦蕩、知行合一 `,
    CompanyCultureValueP7: `6、工作：敬業執著、精益求精`,
    CompanyNews: '公司動態',
    IndustryNews: '行業新聞',
    customerServiceArticleP1: `我們相信，强大的共同價值觀是塑造公司的企業文化、公司發展壯大及永續經營的基石。測吧的價值觀對於我們如何經營業務、招攬人才、考核員工以及决定員工報酬事宜扮演著重要的角色：`,
    customerServiceArticleP2: `1、客戶至上：客戶是公司存在的唯一理由`,
    customerServiceArticleP3: `2、勇於創新：勇於改變，持續創新`,
    customerServiceArticleP4: `3、團隊合作：尊重差异、敢於擔當`,
    customerServiceArticleP5: `4、夢想：綻放生命、永不言弃`,
    customerServiceArticleP6: `5、誠信：真誠坦蕩、知行合一`,
    customerServiceArticleP7: `6、工作：敬業執著、精益求精`,
    CooperationMeetingArticleP1: `商務與科技`,
    CooperationMeetingArticleP2: `上海總部`,
    CooperationMeetingArticleP3: `地址：上海市閔行區恒西路189號愛登堡塔樓7F`,
    CooperationMeetingArticleP4: `電話：021-34799100`,
    CooperationMeetingArticleP5: `傳真：021-34799101`,
    CooperationMeetingArticleP6: `實施與細節`,
    CooperationMeetingArticleP7: `武漢研發中心：`,
    CooperationMeetingArticleP8: `地址：湖北省武漢市江夏區流芳街道光穀金融港匯金中心1號樓2F`,
    CooperationMeetingArticleP9: `電話：027-63495881`,
    CooperationMeetingArticleP10: `傳真：027-63495882`,
    August2019: `2019年8月`,
    August2019Event: `質博士上線（質量及相關資訊查詢與應用平臺）`,
    April2019: `2019年4月`,
    April2019Event: `來簽上線（電子檔簽名雲平臺）`,
    December2018: `2018年12月`,
    December2018Event: `質鏈網上線（富士康科技集團供應鏈品質安全管控平臺）`,
    July2018: `2018年7月`,
    July2018Event: `對接《CNCA自我聲明符合性信息報送系統》（3C自我聲明認證、國推ROHS認證及其他自我聲明認證）`,
    June2018: `2018年6月`,
    June2018Event: `對接《CMA檢驗檢測機構資質認定網上審批系統》《CNAS實驗室/檢驗機構認可業務管理系統》`,
    May2018: `2018年5月`,
    May2018Event: `檢驗檢測認證行業電子檔服務平臺上線`,
    December2017: `2017年12月`,
    December2017Event: `國家認監委電子檔簽名驗證平臺上線（測吧設計並運維）`,
    June2017: `2017年6月`,
    June2017Event: `在上海召開產品新聞發佈會`,
    May2017: `2017年5月`,
    May2017Event: `與國家認監委資訊中心簽署戰略合作協定`,
    May2016: `2016年5月`,
    May2016Event: `來簽系列產品上線（電子檔電子簽名系統）`,
    loadMore: `加載更多`,
    hotLine: `客服熱線:`,
    curtomerCenterP1: `測吧客服中心是公司所有業務的主要服務窗口，負責向客戶解答相關的業務諮詢及受理各種投訴。客服中心致力於不斷完善服務運維體系，向廣大用戶提供全方位、及時周到的服務，包括提供熱線服務、在線回复，網上業務信息安全審核等以實現建造一流的客服中心、培養一流的客服專業人才與測吧一起進步共同成長的願景。`,
    curtomerCenterP2: `優秀的客服管理團隊以及專業化客服人員將為您提供全面、貼心、及時的優質金牌服務。`,
    homeintroduce: `測吧：品質帶來歡樂`,
    homeIntroduceText: `我們通過“開放平臺+資訊智慧平臺+業務定制平臺”的管道，構建以質量為覈心要素的互聯網基礎設施與服務平臺，賦能企業，幫助其供應鏈品質管控安全可信，提質增效。同時生產企業、賣場、電商平臺、檢驗檢測認證機構、消費者和其它類型企業在內的所有參與者借助新技術的力量進行互動，共同來提升品質、享受品質帶來的歡樂，並進入良性互動迴圈`,
    platform: `測吧平臺`,
    toSign: `來簽`,
    toSignIntroduce: `電子檔簽名雲平臺，為企業和個人提供[實名認證]、[線上簽署]、[意願驗證]、[文件管理]、[證據鏈保存]、[訴訟保障]、[保險賠付]等電子檔全生命週期智慧管理服務。借助電腦、手機、平板等設備，隨時隨地完成電子檔的實时簽署並確保其安全、合規、不可篡改。`,
    servicePlatform: `檢驗檢測認證行業電子檔服務平臺`,
    servicePlatformIntroduce: `與中國國家認證認可監督管理委員會資訊中心（已更改為國家市場監督管理總局資訊中心）戰略合作，專業服務於檢驗檢測認證行業和國家認監委相關系統。提供標準査詢、資訊、產品品質報告與認證證書電子化、政務系統檔案流轉電子化等服務。`,
    DrQuality: `質博士`,
    DrQualityIntroduce: `以質量為覈心要素的相關資訊查詢與應用平臺，向企業和個人展示真實可信的產品品質和產品品質的保障能力，同時為製造領域與流通領域的供應鏈品質管控與質量提升提供科技基礎設施服務。`,
    cooperationPlatform: `合作平臺`,
    OnlineVerificationPlatformForIntroduce: `中國國家認證認可監督管理委員會設計的協力廠商電子檔簽名權威驗證平臺，用於驗證電子檔簽名是否被假冒、是否被篡改，解决了電子檔簽名在互聯網流通過程中無法辨別真偽的現實問題，由測吧承建並運維。`,
    QualityChainNetwork: `質鏈網`,
    QualityChainNetworkIntroduce: `質鏈網：富士康科技集團與測吧共同承建的供應鏈質量安全管控平臺，提升供應商管理綜效，助力供應商提質增效，同時賦能上游供應鏈企業以及富士康工業互聯網科技與雲平臺。`,
    introductionCompanyProfile: `測吧通過“開放平臺+資訊智慧平臺+業務定制平臺”的管道，構建以質量為覈心要素的互聯網基礎設施與服務平臺，賦能企業，幫助其供應鏈品質管控安全可信，提質增效。同時生產企業、賣場、電商平臺、檢驗檢測認證機構、消費者和其它類型企業在內的所有參與者借助新技術的力量進行互動，共同來提升品質、享受品質帶來的歡樂，並進入良性互動迴圈。`,
    introductionOfToSign: `來簽：電子檔簽名雲平臺，為企業和個人提供「實名認證」、「線上簽署」、「意願驗證」、「文件管理」、「證據鏈保存」、「訴訟保障」、「保險賠付」等電子檔全生命週期智慧管理服務。借助電腦、手機、平板等設備，隨時隨地完成電子檔的實时簽署並確保其安全、合規、不可篡改。`,
    introductionOfElectronicSignatureDocume: `檢驗檢測認證行業電子檔服務平臺：與中國國家認證認可監督管理委員會資訊中心（已更改為國家市場監督管理總局資訊中心）戰略合作，專業服務於檢驗檢測認證行業和國家認監委相關系統。提供標準査詢、資訊、產品品質報告與認證證書電子化、政務系統檔案流轉電子化等服務。`,
    introductionOfDrQuality: `質博士：以質量為覈心要素的相關資訊查詢與應用平臺，向企業和個人展示真實可信的產品品質和產品品質的保障能力，同時為製造領域與流通領域的供應鏈品質管控與質量提升提供科技基礎設施服務`,
    introductionOfOnlineVerificationPlatformFor: `電子檔簽名驗證平臺：中國國家認證認可監督管理委員會設計的協力廠商電子檔簽名權威驗證平臺，用於驗證電子檔簽名是否被假冒、是否被篡改，解决了電子檔簽名在互聯網流通過程中無法辨別真偽的現實問題，由測吧承建並運維。`,
    introductionOfQualityChainNetwork: `質鏈網：富士康科技集團與測吧共同承建並運維的供應鏈品質安全管控平臺，提升供應商管理綜效，助力供應商提質增效，同時賦能上游供應鏈企業以及富士康工業互聯網科技與雲平臺。`,
    QualityBringsJoys: `品質帶來歡樂`,
    HeraldOfTrueQuality: `真實質量資訊的傳遞者`,
    sell: `銷售`,
    UIDesigner: `UI設計師`,
    Front_endDevelopmentEngineer: `前端開發`,
    JAVAEngineer: `JAVA工程師`,
    JobRequirements: `職位要求`,
    sellJobRequirements1: `1、大專以上學歷；`,
    sellJobRequirements2: `2、具備良好的電話開發客戶的技巧；`,
    sellJobRequirements3: `3、有1年以上電話銷售經驗；`,
    sellJobRequirements4: `4、性格外向，能在壓力下工作；`,
    sellJobRequirements5: `5、溝通能力强，解决問題能力强；`,
    sellJobRequirements6: `6、接受優秀應屆畢業生，有强烈的意願從事銷售工作，敢於挑戰，抗壓力强；`,
    JobResponsibilities: `崗位職責`,
    sellDuty1: `1、開發檢驗、鑒定、測試與認證領域的信息化業務`,
    sellDuty2: `2、維護已開發老客戶並保持良好的關係。`,
    UIDesignerJobRequirements1: ` 1、對色彩運用有良好的基礎，注重用戶體驗，具備較强的審美能力，有較高的平面、美術設計水准;`,
    UIDesignerJobRequirements2: ` 2、學習能力强，能獨立思考，有良好的創意思維和理解能力，富有創新精神;`,
    UIDesignerJobRequirements3: ` 3、精通Photoshop、Dreamweaver、Flash等常用設計軟體，精通DIV CSS，對HTML5有一定瞭解的優先;`,
    UIDesignerJobRequirements4: ` 4、三年以上的平面設計，網頁設計相關工作經驗;`,
    UIDesignerJobRequirements5: ` 5、應聘者需提供優秀設計作品2-3個。`,
    UIDesignerDuty1: `1、參與項目前期介面視覺研究、互動體驗設計。`,
    UIDesignerDuty2: `2、參與專案進度進行UI設計。`,
    UIDesignerDuty3: `3、根據研發進度改寫UI設計流程圖以及進度表。`,
    Front_endDevelopmentEngineerJobRequirements1: `1、三年以上前端頁面製作經驗；`,
    Front_endDevelopmentEngineerJobRequirements2: `2、精通DIV CSS網頁佈局、Html、CSS樣式表，熟悉Web2.0標準，能够解决瀏覽器相容問題；`,
    Front_endDevelopmentEngineerJobRequirements3: `3、熟悉W3C標準，對表現與數據分離、Web語義化等有深刻理解；`,
    Front_endDevelopmentEngineerJobRequirements4: `4、對常見的前端效能問題有清晰的認識，能够主導前端的性能優化；`,
    Front_endDevelopmentEngineerJobRequirements5: `5、熟練掌握Photoshop，會基本的切圖操作；`,
    Front_endDevelopmentEngineerJobRequirements6: `6、應聘者需提供優秀設計作品2-3個。`,
    Front_endDevelopmentEngineerDuty1: ` 1、Web應用的設計與開發；`,
    Front_endDevelopmentEngineerDuty2: `2、Javascript資料處理；`,
    Front_endDevelopmentEngineerDuty3: `3、複雜Ajax互動開發；`,
    JAVAEngineerJobRequirements1: `1、專科以上學歷，具備閱讀英語技術開發手册等檔案。`,
    JAVAEngineerJobRequirements2: `2、精通Java開發，熟悉J2EE體系結構，擁有2年以上實際開發經驗，參與開發過2個以上大型項目。`,
    JAVAEngineerJobRequirements3: `3、熟練掌握HTML、javascript、CSS等web開發科技。`,
    JAVAEngineerJobRequirements4: `4、至少能够熟練使用一種主流資料庫，對資料庫有一定理解，熟練掌握SQL語句，有較好的資料庫設計能力。`,
    JAVAEngineerJobRequirements5: `5、能熟練配寘使用apache、websphere、tomcat、weblogic等。`,
    JAVAEngineerDuty1: `1、需求分析、系統設計工作，完成系統需求分析、設計說明書編寫；`,
    JAVAEngineerDuty2: `2、負責按照要求完成各類設計檔案，並參與開發。`,
    JAVAEngineerDuty3: `3、使用JAVA與資料庫語言進行專案開發。`,
    enterpriseMailbox: `企業郵箱`










  }
}



// WEBPACK FOOTER //
// ./src/i18n/languages/TW.js